import { TextAreaInput } from "@jugl-web/ui-components/cross-platform/forms/TextAreaInput";
import { useTranslations } from "@jugl-web/utils";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { useState } from "react";
import { useInvoicesConfigList } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/pages/InvoicesBusinessInformationPage/hooks/useInvoicesConfigList";
import { ReactComponent as ReloadIcon } from "./assets/reload.svg";

export const BillFromField = () => {
  const { t } = useTranslations();
  const { register, formValues, errors, resetBillFromField } =
    useInvoicesItemFormPageContext();
  const [isChanged, setIsChanged] = useState(false);
  const { configId } = useInvoicesConfigList();

  return (
    <>
      {isChanged && configId ? (
        <div className="relative z-10 w-full max-w-xl">
          <button
            type="button"
            className="absolute right-1 -bottom-9 translate-y-full transform cursor-pointer border-none bg-transparent p-0"
            onClick={() => {
              resetBillFromField();
              setIsChanged(false);
            }}
          >
            <ReloadIcon />
          </button>
        </div>
      ) : null}
      <TextAreaInput
        isRequired
        errorMessage={errors.billFrom?.message}
        isInvalid={!!errors.billFrom}
        label={t({
          id: "invoices.item.billFrom",
          defaultMessage: "Bill from",
        })}
        value={formValues.billFrom}
        {...register("billFrom", {
          onChange: () => {
            setIsChanged(true);
          },
          validate: (value) => (!value.trim() ? "Mandatory field" : undefined),
        })}
        classNames={{
          inputWrapperClassName: "h-40 max-w-xl",
          inputClassName:
            "min-h-full max-h-full jugl__custom-scrollbar overflow-y-auto",
        }}
      />
    </>
  );
};
